<template>
  <span>
    <v-list-item class="text-center">
      <v-btn
        :id="`${idPrefix}_QuickHelp`"
        :href="helpLink"
        class="quick_help_button"
        target="_blank"
        icon
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-icon class="material-icons" v-bind="attr" v-on="on">
              question_mark
            </v-icon>
          </template>
          <span :id="`${idPrefix}_Help_TooltipText`">Open the user guide</span>
        </v-tooltip>
      </v-btn>
    </v-list-item>
  </span>
</template>
<script>
export default {
  name: 'QuickHelpButton',
  props: {
    idPrefix: {
      type: String,
      default: 'QuickHelp_',
    },
    userGuideIdentifier: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      quickHelpVersion: '0.0',
    };
  },
  computed: {
    helpLink() {
      const domain = 'https://docs.sphereco.com';
      if (this.userGuideIdentifier.hasOwnProperty('module')) {
        const module = this.userGuideIdentifier.module;
        const card = this.userGuideIdentifier.card
          ? '#' + this.userGuideIdentifier.card
          : '';
        let { quickHelpVersion: version } = this;
        return `${domain}/${module}-${version}${card}`;
      } else return domain;
    },
  },
  mounted() {
    const versionInputElem = document.getElementById('sb-version');
    if (versionInputElem) {
      let versionNumbers = versionInputElem.value.split('.');
      this.quickHelpVersion = versionNumbers[0] + '.' + versionNumbers[1];
    }
  },
};
</script>

<style>
.quick_help_button {
  text-decoration: none !important;
  font-size: 16px !important;
}

.sb-table-top-actions .v-btn.quick_help_button {
  padding-left: 8px;
  padding-right: 8px;
}
</style>
